import client from "./client";

const notificationsApi = {
  list(params = {}) {
    return client.get("/notifications", { params }).then((r) => r.data);
  },

  markRead(id) {
    return client.patch(`/notifications/${id}/read`).then((r) => r.data);
  },

  markAllRead() {
    return client.patch("/notifications/read-all").then((r) => r.data);
  },

  subscribePush(subscription) {
    return client.post("/notifications/push/subscribe", { subscription }).then((r) => r.data);
  },

  // Notify all students in a class
  notifyClass(className, type, title, message, url = "/", metadata = {}) {
    return client
      .post("/notifications/notify-class", {
        className,
        type,
        title,
        message,
        url,
        metadata,
      })
      .then((r) => r.data);
  },
};

export default notificationsApi;
